import React from 'react'

export const PreferencesOptionName: React.FC<{option:string}> = ({option}) => {
  return (
    <p className="text-[14px] leading-[25px] font-bold text-primary cursor-pointer">{option}</p>
  )
}
